import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { authService } from "../../services";
import { Panel, PhoneField, TextField, isValidPhone } from "../../components/ui";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    fullname: "",
    phone: "",
    email: "",
    address: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authService.isLoggedIn()) navigate("/profile", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (key) => (event) => setForm((prev) => ({ ...prev, [key]: event.target.value }));

  const validate = () => {
    if (!form.fullname) return "กรุณากรอกชื่อ-นามสกุล";
    if (!form.phone) return "กรุณากรอกเบอร์โทรศัพท์";
    if (!isValidPhone(form.phone)) return "เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก";
    if (!form.email) return "กรุณากรอกอีเมล";
    if (!EMAIL_PATTERN.test(form.email)) return "รูปแบบอีเมลไม่ถูกต้อง";
    if (!form.address) return "กรุณากรอกที่อยู่";
    if (!form.password) return "กรุณากรอกรหัสผ่าน";
    if (form.password.length < 6) return "รหัสผ่านต้องมี 6 ตัวอักษรขึ้นไป";
    if (form.password !== form.confirmPassword) return "รหัสผ่านไม่ตรงกัน";
    return "";
  };

  const submit = async (event) => {
    event.preventDefault();
    const message = validate();
    setError(message);
    if (message) return;

    setLoading(true);
    try {
      await authService.register(form);
      navigate("/login", { state: { registered: true } });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageBanner title="บริการครอบคลุมมากกว่า 200 เกม" breadcrumb={[{ label: "สมัครสมาชิก" }]} seed={9} />

      <div className="lucid-container" style={{ marginTop: -70, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel style={{ maxWidth: 760, margin: "0 auto" }}>
          <h2 className="lt-panel__title lt-mb-24">สมัครสมาชิก</h2>

          <form onSubmit={submit}>
            <div className="lt-grid-2">
              <TextField label="ชื่อ-นามสกุล" placeholder="ชื่อ-นามสกุล" value={form.fullname} onChange={onChange("fullname")} />
              <PhoneField label="เบอร์โทรศัพท์" value={form.phone} onChange={onChange("phone")} />
            </div>

            <TextField label="อีเมล" type="email" placeholder="อีเมลที่ใช้เข้าสู่ระบบ" value={form.email} onChange={onChange("email")} />
            <TextField label="ที่อยู่" placeholder="ที่อยู่สำหรับออกใบเสร็จ / จัดส่งสินค้า" value={form.address} onChange={onChange("address")} />

            <div className="lt-grid-2">
              <TextField
                label="รหัสผ่าน"
                type="password"
                placeholder="อย่างน้อย 6 ตัวอักษร"
                value={form.password}
                onChange={onChange("password")}
                autoComplete="new-password"
              />
              <TextField
                label="ยืนยันรหัสผ่าน"
                type="password"
                placeholder="กรอกรหัสผ่านอีกครั้ง"
                value={form.confirmPassword}
                onChange={onChange("confirmPassword")}
                autoComplete="new-password"
              />
            </div>

            {error ? <p className="lt-helper lt-helper--danger">{error}</p> : null}

            <button type="submit" className="lt-btn lt-btn--teal lt-btn--block" disabled={loading}>
              {loading ? "กำลังสมัคร..." : "สมัครสมาชิก"}
            </button>
          </form>

          <p className="lt-text-center lt-text-muted lt-mt-24" style={{ fontSize: 14 }}>
            การสมัครสมาชิกถือว่ายอมรับ <Link to="/policy">นโยบายความเป็นส่วนตัว</Link> และข้อกำหนดการใช้งาน
          </p>

          <div className="lt-flex-between" style={{ fontSize: 14 }}>
            <span className="lt-text-muted">มีบัญชีอยู่แล้ว?</span>
            <Link to="/login">เข้าสู่ระบบ</Link>
          </div>
        </Panel>
      </div>
    </Layout>
  );
}
